import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["userId"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQuery } from 'react-query';
import api from 'utils/api';
import hubDomainKeys from './queryKeys';
function useFetchUserHubs() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    userId = _ref.userId,
    queryOptions = _objectWithoutProperties(_ref, _excluded);
  function fetchHubs() {
    return _fetchHubs.apply(this, arguments);
  }
  function _fetchHubs() {
    _fetchHubs = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var path;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            path = userId ? "/api/users/".concat(userId, "/hubs") : '/api/me/hubs';
            return _context.abrupt("return", api('get', path, null));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchHubs.apply(this, arguments);
  }
  return useQuery(hubDomainKeys.myHubs(userId), fetchHubs, _objectSpread(_objectSpread({}, queryOptions), {}, {
    staleTime: 5 * 60 * 1000
  }));
}
export default useFetchUserHubs;